import { useEffect, useState } from "react";
import { EmailSettingsType } from "../../types/EmailSetingsType";
import { useEmailSettings } from "../../hooks/useEmailSettings";
import { useForm } from "react-hook-form";
import { createEmailSettings, deleteEmailSettings, updateEmailSettings } from "../../services/user/EmailSettings";
import toast from "react-hot-toast";
import TextFieldComponent from "../../components/inputs/Textfield/TextfieldComponent";
import { Button, Card, Flex,  } from "@radix-ui/themes";
import { EyeClosedIcon, EyeOpenIcon } from "@radix-ui/react-icons";
import { ConfirmAlertDialog } from "../../components/common/ConfirmAlertDialog";
import { deleteEsuraApiConnectionProperties } from "../../services/esuraApiConnectionProperties";
import EmailSettingsFormValidation from "../Courses/EmailSetingsFormValidation";
import { yupResolver } from "@hookform/resolvers/yup";
import { ref } from "yup";




    
 const EmailSettings = () => {
    const [showSendPassword, setShowSendPassword] = useState(false);
  const [showReceivePassword, setShowReceivePassword] = useState(false);



  const {
    data: dataEmail,
    isLoading: isLoadingEmail,
    refetch: refetchEmail,
  } = useEmailSettings({
    enabled: true,
    refetchOnWindowFocus: false,
  });
  const [updateEmail, setUpdateEmail] = useState<EmailSettingsType | null>(
    null
  );
  const [saveEmail, setSaveEmail] = useState<EmailSettingsType | null>(null);
  const [removeEmail, setRemoveEmail] = useState<EmailSettingsType | null>(
    null
  );

  const {
    control: controlEmail,
    handleSubmit: handleSubmitEmail,
    reset: resetEmail,
    formState: { errors: errorsEmail },
  } = useForm<EmailSettingsType>({ 
    resolver: yupResolver(EmailSettingsFormValidation),
    defaultValues: dataEmail
    
  });
    const confirmUpdateEmail = async () => {
    if (updateEmail) {
      await updateEmailSettings(updateEmail);
      toast.success("Configuração Email atualizada!");
      setUpdateEmail(null);
      refetchEmail();
    }
  };


    const confirmSaveEmail = async () => {
       if (saveEmail) {
         await createEmailSettings(saveEmail);
         toast.success("Configuração Email salva com sucesso!");
         setSaveEmail(null);
         refetchEmail();
       }
     };
   
     const confirmRemoveEmail = async () => {
    if (removeEmail?.id) {
      await deleteEmailSettings(removeEmail.id);
      toast.success("Configuração removida!");
      setRemoveEmail(null);
      refetchEmail()
      resetEmail();
    }
  };
  
    useEffect(() => {
      if (dataEmail?.id) resetEmail(dataEmail);
    }, [dataEmail, resetEmail]);
  
    const handleEmailSubmit = (values: EmailSettingsType) => {
      if (dataEmail?.id) {
        setUpdateEmail(values);
      } else {
        setSaveEmail(values);
      }
    };

    return( 
    <>
      <form onSubmit={ handleSubmitEmail(handleEmailSubmit)} noValidate>
        <Flex direction="row" gap="4" mt="4" wrap="wrap">
          
          <Card style={{ flex: 1, minWidth: 320, padding: 20 }}>
            <Flex direction="column" gap="3">
              <TextFieldComponent
                name="sendHost"
                label="Servidor de Envio"
                control={controlEmail}
                errors={errorsEmail}
                fieldProps={{ placeholder: "ex: smtp.gmail.com" }}
              />

              <TextFieldComponent
                name="sendPort"
                label="Porta de Envio"
                control={controlEmail}
                errors={errorsEmail}
                fieldProps={{ type: "number", placeholder: "587" }}
              />

              <TextFieldComponent
                name="sendFrom"
                label="Email Remetente"
                control={controlEmail}
                errors={errorsEmail}
                fieldProps={{ type: "email", placeholder: "seu@email.com" }}
              />

              <TextFieldComponent
                name="sendUsername"
                label="Usuário de Envio"
                control={controlEmail}
                errors={errorsEmail}
                fieldProps={{ placeholder: "usuário SMTP" }}
              />

              <div style={{ position: "relative", width: "100%" }}>
                <TextFieldComponent
                  name="sendPassword"
                  label="Senha de Envio"
                  control={controlEmail}
                  errors={errorsEmail}
                  fieldProps={{
                    type: showSendPassword ? "text" : "password",
                    placeholder: "********",
                  }}
                />
                <button
                  type="button"
                  onClick={() => setShowSendPassword((p) => !p)}
                  style={{
                    position: "absolute",
                    right: 12,
                    top: 38,
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  {showSendPassword ? <EyeOpenIcon /> : <EyeClosedIcon />}
                </button>
              </div>
            </Flex>
          </Card>

         
          <Card style={{ flex: 1, minWidth: 320, padding: 20 }}>
            <Flex direction="column" gap="3">
              <TextFieldComponent
                name="receiveHost"
                label="Servidor de Recebimento"
                control={controlEmail}
                errors={errorsEmail}
                fieldProps={{ placeholder: "imap.gmail.com" }}
              />

              <TextFieldComponent
                name="receivePort"
                label="Porta de Recebimento"
                control={controlEmail}
                errors={errorsEmail}
                fieldProps={{ type: "number", placeholder: "993" }}
              />

              <TextFieldComponent
                name="receiveFrom"
                label="Email de Recebimento"
                control={controlEmail}
                errors={errorsEmail}
                fieldProps={{ type: "email", placeholder: "usuario@email.com" }}
              />

              <TextFieldComponent
                name="receiveUsername"
                label="Usuário de Recebimento"
                control={controlEmail}
                errors={errorsEmail}
                fieldProps={{ placeholder: "usuário IMAP" }}
              />

              <div style={{ position: "relative", width: "100%" }}>
                <TextFieldComponent
                  name="receivePassword"
                  label="Senha de Recebimento"
                  control={controlEmail}
                  errors={errorsEmail}
                  fieldProps={{
                    type: showReceivePassword ? "text" : "password",
                    placeholder: "********",
                  }}
                />
                <button
                  type="button"
                  onClick={() => setShowReceivePassword((p) => !p)}
                  style={{
                    position: "absolute",
                    right: 12,
                    top: 40,
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  {showReceivePassword ? <EyeOpenIcon /> : <EyeClosedIcon />}
                </button>
              </div>
            </Flex>
          </Card>
        </Flex>

        <Flex direction="row" gap="3" justify="end" mt="4">
          {dataEmail?.id ? (
            <>
              <Button type="submit" color="blue" onClick={() => setUpdateEmail(dataEmail)}>
                Atualizar
              </Button>
              <Button
                type="button"
                color="red"
                onClick={() => setRemoveEmail(dataEmail)}
              >
                Remover
              </Button>
            </>
          ) : (
            <Button type="submit" color="green">
              Salvar
            </Button>
          )}
        </Flex>
      </form>

  
      <ConfirmAlertDialog
        open={!!saveEmail}
        onOpenChange={(open) => !open && setSaveEmail(null)}
        title="Salvar configuração de Email"
        item={saveEmail}
        onConfirm={confirmSaveEmail}
        onCancel={() => setSaveEmail(null)}
      />

      <ConfirmAlertDialog
        open={!!updateEmail}
        onOpenChange={(open) => !open && setUpdateEmail(null)}
        title="Atualizar configuração de Email"
        item={updateEmail}
        onConfirm={confirmUpdateEmail}
        onCancel={() => setUpdateEmail(null)}
      />

      <ConfirmAlertDialog
        open={!!removeEmail}
        onOpenChange={(open) => !open && setRemoveEmail(null)}
        title="Remover configuração de Email"
        item={removeEmail}
        onConfirm={confirmRemoveEmail}
        onCancel={() => setRemoveEmail(null)}
      />
    </>
    
  );
};
export default EmailSettings;